import React from "react";
import { formatCurrency } from "../offerJoiningUtils";

const OFFER_STAMP = "/img/offer_stamp.png";

export const customFontFamily = {
  bold: "font-bold",
  normal: "font-normal",
  semibold: "font-semibold",
  boldFont: "font-bold",
  normalFont: "",
  italic: "italic",
};

export const config = {
  fontSizeXs: "text-xs",
  fontSizeSm: "text-[11px]",
  fontSizeBase: "text-[12px]",
  fontSizeLg: "text-[12.5px]",
  fontSizeTitle: "text-sm",
};

const SignatureBlock = ({ candidateName, joiningDateFormatted }) => (
  <div className={`grid grid-cols-2 gap-8 items-start ${config.fontSizeTitle} pt-4 my-4`}>
    <div className="flex flex-col items-start justify-start">
      <img src={OFFER_STAMP} alt="Authorized Signatory Stamp" className="h-[100px] object-contain object-left-top" />
    </div>

    <div className="text-left pl-6 flex flex-col gap-3 pt-1">
      <div className={`${customFontFamily.bold} text-gray-900`}>Accepted & Confirmed Above</div>
      <div className="flex items-center gap-2">
        <span className={customFontFamily.bold}>Signature:</span>
        <div className="border-b border-gray-400 flex-1 h-3"></div>
      </div>
      <div className="space-y-1">
        <div className="flex gap-2">
          <span className={customFontFamily.bold}>Name:</span>
          <span className={`uppercase ${customFontFamily.semibold}`}>{candidateName}</span>
        </div>
        <div className="flex gap-2">
          <span className={customFontFamily.bold}>Date:</span>
          <span>{joiningDateFormatted}</span>
        </div>
      </div>
    </div>
  </div>
);

const FulltimeOfferPDF = ({
  candidateName,
  candidateAddress,
  candidateMobile,
  candidateEmail,
  candidateLocation,
  position,
  offerRefCode,
  offerDateFormatted,
  joiningDateFormatted,
  note16,
  note17,
  basicM,
  basicY,
  houseM,
  houseY,
  eduM,
  eduY,
  medM,
  medY,
  convM,
  convY,
  personalM,
  personalY,
  cityM,
  cityY,
  otherM,
  otherY,
  subAM,
  subAY,
  pfM,
  pfY,
  gratuityY,
  healthY,
  perfoY,
  subBY,
  totalY,
}) => {
  return (
    <div className={`bg-white text-gray-900 ${config.fontSizeLg} space-y-6`} style={{ fontFamily: "'Arial', 'Helvetica', sans-serif" }}>
      {/* PAGE 1 CONTENT */}
      <div className="space-y-4">
        <div className={`flex justify-between items-center ${customFontFamily.semibold} text-gray-800 ${config.fontSizeXs} mb-5 pb-1`}>
          <div>{offerRefCode}</div>
          <div>Date: {offerDateFormatted}</div>
        </div>

        <div className="space-y-0.5 text-gray-900">
          <div>To,</div>
          <div className={`${customFontFamily.bold} ${config.fontSizeTitle}`}>{candidateName},</div>
          {candidateAddress && <div>Address: {candidateAddress}</div>}
          {candidateMobile && <div>Mobile: {candidateMobile}</div>}
          {candidateEmail && <div>Email: {candidateEmail}</div>}
        </div>

        <div className={customFontFamily.semibold}>Dear {candidateName.split(" ")[0]},</div>

        <div className={`${customFontFamily.bold} text-gray-900 ${config.fontSizeTitle} underline`}>
          Sub: Offer Letter with Salary Break-up
        </div>

        <div className="space-y-3 text-justify leading-relaxed">
          <p>
            Referring to your application and the interview you attended with us, we are delighted to offer you the position of <span className={customFontFamily.bold}>"{position || "Project Coordinator and Business Development Executive"}"</span> with DYC Global Private Limited, Thane.
          </p>

          <p>
            Please refer to the attached Salary Break-up (CTC Annexure A) for details of your remuneration.
          </p>

          <p>
            You are required to report on your duties on or before <span className={customFontFamily.bold}>{joiningDateFormatted}</span>, at <span className={customFontFamily.bold}>9:30 am</span> and you shall be reporting to <span className={customFontFamily.bold}>Ms. Komal Dushing- Line Manager & Mr. Parag Wadekar – MD Technical</span>.
          </p>

          <div>
            <div className={`${customFontFamily.semibold} mb-1`}>Your place of reporting / work will be our Thane office.</div>
            <div className={`${customFontFamily.bold} pl-2 text-gray-900`}>
              DYC Global Pvt. Ltd.<br />
              702, Lodha Supremus,<br />
              District-II, Kolshet,<br />
              Thane West – 400607.
            </div>
          </div>

          <p>
            However, you may be required to work anywhere in India, if the company so directs, based on the exigencies of work.
          </p>

          <div>
            <div className={`${customFontFamily.semibold} mb-1.5`}>Please provide the following documents on or before the joining date:</div>
            <ul className="list-disc pl-5 space-y-1 text-gray-800">
              <li>2 Nos. Colour Passport Size Photograph with White Background.</li>
              <li>Proof of Salary drawn from previous employer. (Last 3 months' salary slips if applicable).</li>
              <li>Relieving Letters from last employer.</li>
              <li>Experience certificates from last employer.</li>
              <li>Self-attested PANCARD Copy.</li>
              <li>Aadhar Card copy or any other permanent address Proof & contact details.</li>
              <li>Copies of Credentials / Educational certificates / Testimonials.</li>
              <li>Professional Certification / Courses (NDT Test Certificates).</li>
            </ul>
          </div>
        </div>
      </div>

      <hr className="border-gray-200" />

      {/* PAGE 2 CONTENT */}
      <div className="space-y-3 text-justify leading-relaxed">
        <p>
          This offer will remain valid for 7 working days from the date of issuance. Please confirm your date of joining by signing and returning the attached Salary Break-up.
        </p>
        <p>
          In case of any delay, the company reserves the right to withdraw or cancel this offer.
        </p>
        <p>
          This offer is contingent upon successfully clearing the client interview (if required), receiving client approval, and completing a satisfactory reference check.
        </p>
        <p>
          The detailed Appointment Letter will be issued within 7 working days of your joining.
        </p>
        <p>
          We look forward to a long-term and mutually beneficial association.
        </p>

        <SignatureBlock candidateName={candidateName} joiningDateFormatted={joiningDateFormatted} />
      </div>

      <hr className="border-gray-200" />

      {/* PAGE 3 CONTENT */}
      <div>
        <div className={`space-y-0.5 ${customFontFamily.semibold} ${config.fontSizeXs} mb-2 text-gray-900`}>
          <div>Name: {candidateName}</div>
          <div>Location: {candidateLocation || "Thane, Mumbai"}</div>
          <div>Designation: {position}</div>
          <div>Department: Inspection / Business Development</div>
          <div>Grade: K1</div>
        </div>

        <div className={`text-center ${customFontFamily.bold} ${config.fontSizeTitle} underline mb-2 text-gray-900 uppercase tracking-wide`}>
          CTC Annexure A - Salary Break-up
        </div>

        <table className={`w-full border-collapse border border-gray-400 ${config.fontSizeXs} my-1`}>
          <thead>
            <tr className={`bg-gray-100 ${customFontFamily.bold} border-b border-gray-400 text-gray-900`}>
              <th className="border border-gray-400 px-3 py-1 align-middle text-left w-1/2">Particulars</th>
              <th className="border border-gray-400 px-3 py-1 align-middle text-right w-1/4">Monthly (INR)</th>
              <th className="border border-gray-400 px-3 py-1 align-middle text-right w-1/4">Yearly (INR)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Basic Salary</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(basicM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(basicY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">House Rent Allowance</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(houseM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(houseY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Education Allowance</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(eduM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(eduY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Medical Reimbursement</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(medM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(medY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Conveyance</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(convM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(convY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Personal Allowance</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(personalM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(personalY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">City Compensatory Allowance</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(cityM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(cityY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Other Allowance</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(otherM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(otherY)}</td>
            </tr>
            <tr className={`${customFontFamily.bold} ${config.fontSizeXs} bg-gray-100 border-t border-b border-gray-400`}>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Sub Total (A)</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(subAM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(subAY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Company's Contribution to P.F.</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(pfM)}</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(pfY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Company's Contribution to Gratuity (4.81%)</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right"></td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(gratuityY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Annual Health checkup</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right"></td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(healthY)}</td>
            </tr>
            <tr>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Performance Incentive</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right"></td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(perfoY)}</td>
            </tr>
            <tr className={`${customFontFamily.bold} ${config.fontSizeXs} bg-gray-100 border-t border-b border-gray-400`}>
              <td className="border border-gray-400 px-3 py-0.5 align-middle">Sub Total B</td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right"></td>
              <td className="border border-gray-400 px-3 py-0.5 align-middle text-right">{formatCurrency(subBY)}</td>
            </tr>
            <tr className={`${customFontFamily.bold} ${config.fontSizeXs} bg-gray-200 border-t-2 border-gray-400`}>
              <td className="border border-gray-400 px-3 py-1 align-middle">Total (A+B)</td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right"></td>
              <td className="border border-gray-400 px-3 py-1 align-middle text-right">{formatCurrency(totalY)}</td>
            </tr>
          </tbody>
        </table>

        <div className="mt-3">
          <div className={`${customFontFamily.bold} underline mb-1 ${config.fontSizeXs}`}>Notes:</div>
          <ol className={`list-decimal pl-4 space-y-1.5 text-justify ${config.fontSizeSm} leading-relaxed text-gray-800`}>
            <li>This offer is subject to satisfactory reference checks conducted by the Company.</li>
            <li>Your primary place of work shall be Lodha Supremus, Thane (West). However, depending on business requirements, you may be required to work at any other location within India. You may also be required to provide services to the Company's subsidiaries, affiliates, or associates, as and when directed.</li>
            <li>The disbursement of salary and related components will be governed by the Company's Service Rules, as applicable and amended from time to time.</li>
            <li>Performance Incentive shall be governed by the overall performance of the Company, your individual performance, and the discretion of Management. The entitlement and qualifying criteria will be determined on a year-to-year basis in accordance with the Company's incentive scheme and rules.</li>
          </ol>
        </div>
      </div>

      <hr className="border-gray-200" />

      {/* PAGE 4 CONTENT */}
      <div>
        <ol start="5" className={`list-decimal pl-4 space-y-2 text-justify ${config.fontSizeSm} leading-relaxed text-gray-800`}>
          <li>Provident Fund, Professional Tax, and Income Tax shall be deducted from your salary in accordance with statutory provisions, effective from your date of joining. Gratuity benefits shall also be applicable from your date of joining, in line with statutory requirements.</li>
          <li>Expenses relating to Books & Periodicals, Telephone/Mobile/Data Card, Lunch Subsidy, and Travelling may be claimed as reimbursements on submission of valid bills, subject to limits prescribed by the Company. Such reimbursements shall qualify for tax exemption in accordance with prevailing laws. Reimbursement of First-Class Train Travel expenses shall also be available on submission of bills, subject to applicable limits. These benefits will be effective from your date of joining.</li>
          <li>Group Health Insurance and Group Personal Accident Insurance coverage shall be provided as per Company policies, effective upon confirmation of your employment.</li>
          <li>Leave entitlements, including Casual Leave (CL), Privilege Leave (PL), and Sick Leave (SL), shall be applicable only after confirmation of your employment, in accordance with the Company's leave policy.</li>
          <li>You will initially be on probation for a period of six months (or such other period as may be communicated). Upon successful completion and subject to performance review, your services may be confirmed in writing.</li>
          <li>Your employment with the Company may be terminated by either party by giving 15 days' prior written notice or by making payment in lieu of such notice, in accordance with the Company's Service Rules and applicable laws. The Company reserves the right to relieve you from your duties with immediate effect upon payment of salary in lieu of the notice period.</li>
          <li>You are required to maintain the highest standards of integrity, confidentiality, and professional conduct during your employment. You shall not, without prior written approval, disclose any confidential or proprietary information of the Company to any third party.</li>
          <li>Your retirement shall be in accordance with the Company's policy and applicable statutory provisions.</li>
          <li>You are required to comply with all applicable laws, regulations, and Company policies, as amended from time to time.</li>
          <li>Upon your acceptance of this offer and completion of the necessary joining formalities, a formal Appointment Letter shall be issued to you.</li>
          <li>Normal working hours shall be 9:30 am to 6:00 pm from Monday to Saturday.</li>
        </ol>
      </div>

      <hr className="border-gray-200" />

      {/* PAGE 5 CONTENT */}
      <div className="space-y-3 text-justify leading-relaxed">
        <ol start="16" className={`list-decimal pl-4 space-y-2 text-justify ${config.fontSizeSm} leading-relaxed text-gray-800 [word-break:break-word] break-words break-all`}>
          <li className="[word-break:break-word] break-words break-all whitespace-pre-wrap">{note16 || "As part of your responsibilities in Project Operations & Business Development Executive, you are expected to maintain the highest standards of professional decorum across all digital and social platforms utilized for official activities. Your LinkedIn and other professional profiles must remain updated to accurately reflect your role and association with the organization. All communications, representations, and interactions through these platforms should consistently align with the company's values, code of conduct, and brand image."}</li>
          <li className="[word-break:break-word] break-words break-all whitespace-pre-wrap">{note17 || "No allowance will be paid for daily office travel. For external client visits, travel will be reimbursed as per company policy within Mumbai. Payments will be made on the 15th of the subsequent month."}</li>
        </ol>

        <SignatureBlock candidateName={candidateName} joiningDateFormatted={joiningDateFormatted} />
      </div>
    </div>
  );
};

export default FulltimeOfferPDF;
